import { phpInstance } from "@/plugins/axios";

const firstAdmissionService = {};

firstAdmissionService.getImageAndWordToConfirmation = () => {
  return phpInstance.post(`/user/flow/toSelectImageAndword`);
};

firstAdmissionService.firstLogin = obj => {
  return phpInstance.post(`/user/flow/toCreateID`, obj);
};

export default firstAdmissionService;
